export default __webpack_public_path__ + "static/media/biometricAccessControlSystem.3b8d89c8.svg";